import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { decryptToken } from "./utils/getToken";

const UserRegisterPasswordModal = ({ isOpen, setIsOpen, adminId, adminName }) => {
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const urlmain = API_BASE_URL;
    const token = decryptToken("accessToken") || "";

    useEffect(() => {
        if (!isOpen) {
            setNewPassword("");
            setConfirmPassword("");
        }
    }, [isOpen]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!newPassword.trim()) {
            toast.error("Please enter a new password");
            return;
        }

        if (newPassword.length < 6) {
            toast.error("Password must be at least 6 characters");
            return;
        }

        if (newPassword !== confirmPassword) {
            toast.error("Passwords do not match");
            return;
        }

        setLoading(true);
        try {
            const response = await fetch(
                `${urlmain}/register/super-reset-password/${adminId}`,
                {
                    method: "PUT",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify({ newPassword }),
                }
            );
            const res = await response.json();

            if (response.ok) {
                toast.success(res.message || "Password updated successfully");
                setIsOpen(false);
            } else {
                toast.error(res.message || "Failed to update password");
            }
        } catch (error) {
            toast.error("Failed to update password");
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="custom-modal-overlay" onClick={() => setIsOpen(false)}>
            <div
                className="custom-modal-content"
                onClick={(e) => e.stopPropagation()}
            >
                <h2 className="oms-modal-title">Change Password</h2>
                {adminName && (
                    <p style={{ textAlign: "center", marginBottom: "16px", fontSize: "14px" }}>
                        {adminName}
                    </p>
                )}
                <form className="oms-modal-form" onSubmit={handleSubmit}>
                    <div className="oms-form-group">
                        <label htmlFor="newPassword" className="oms-form-label">
                            New Password
                        </label>
                        <input
                            type="password"
                            id="newPassword"
                            name="newPassword"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            placeholder="Enter new password"
                            required
                            minLength={6}
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="confirmPassword" className="oms-form-label">
                            Confirm Password
                        </label>
                        <input
                            type="password"
                            id="confirmPassword"
                            name="confirmPassword"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            placeholder="Confirm new password"
                            required
                            minLength={6}
                        />
                    </div>
                    <div className="oms-form-actions">
                        <button type="button" onClick={() => setIsOpen(false)}>
                            Cancel
                        </button>
                        {loading ? (
                            <button type="button" disabled>
                                Loading...
                            </button>
                        ) : (
                            <button type="submit">Update Password</button>
                        )}
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UserRegisterPasswordModal;
